import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.whiteLabel.spacing.sp16};
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${props => props.theme.whiteLabel.spacing.sp8};
  text-align: center;
`

export const ContactContainer = styled.div`
  display: flex;
  justify-content: center;

  a {
    text-decoration: none;
  }
`
